import React from 'react';
import { useHistory } from 'react-router-dom';
import { cnpj, cpf } from 'utils';
import { useTranslation, usePermissions } from 'hooks';
import { Client } from 'interfaces/client';
import { ClientCode } from 'interfaces/client-codes';
import { translations } from './translations';
import * as S from './styles';

interface IGridClientsProps {
  clients: Client[] | Record<string, any>[];
}

interface IClientProps {
  client: Client | Record<string, any>;
}

const Item: React.FC<IClientProps> = ({ client }) => {
  const history = useHistory();
  const cpfCnpjFormated = cnpj(client.cnpj) || cpf(client.cpf) || '---';
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission('editClient');
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/client/${client.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{client.id}</S.ItemValue>
        <S.ItemValue>{cpfCnpjFormated}</S.ItemValue>
        <S.ItemValue>
          {client.clientType ? client.clientType.name : '---'}
        </S.ItemValue>
        <S.ItemValue>
          {client.company_name || client.trade_name || '---'}
        </S.ItemValue>
        <S.ItemValue>
          {client.clientCodes.length > 0
            ? client.clientCodes
                .map((code: ClientCode) => code.client_code)
                .join(', ')
            : '---'}
        </S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridClients: React.FC<IGridClientsProps> = ({ clients = [] }) => {
  const { getTranslation } = useTranslation(translations);

  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation('id')}</S.Label>
        <S.Label>{getTranslation('cnpjRaiz')}</S.Label>
        <S.Label>{getTranslation('customizacao')}</S.Label>
        <S.Label>{getTranslation('razaoSocial')}</S.Label>
        <S.Label>{getTranslation('codigoSAP')}</S.Label>
      </S.Header>
      {clients.length > 0 &&
        clients.map((client) => <Item client={client} key={client.id} />)}
    </S.Container>
  );
};
